import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListSubheader from "@mui/material/ListSubheader";
import { Grid, Tooltip } from "@mui/material";
import { withStyles } from "@mui/styles";
import IconButton from "@mui/material/IconButton";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import PropTypes from "prop-types";

import { useUser } from "../../auth/UserProvider";

const StyleMenu = withStyles((_theme) => ({
  paper: {
    maxHeight: 200,
    width: "280px",
    overflowY: "auto",
    margin: 0,
    padding: 0,
    listStyle: "none",
    height: "100%",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,.1)",
      // outline: "1px solid slategrey"
    },
  },
}))(Menu);

const StyledListSubheader = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}))(ListSubheader);

const GroupList = ({ open, anchorEl, handleClose }) => {
  const { groups, networkUser: user } = useUser();

  const [success, setSuccess] = React.useState(false);

  const handleCopy = (_e) => {
    _e.preventDefault();
    const groupList = groups.join(", ");
    const template = `User: ${user}, Groups: ${groupList}`;

    if (navigator.clipboard !== undefined) {
      //Chrome
      navigator.clipboard.writeText(template).then(
        function () {
          setSuccess(true);
          setTimeout(function () {
            setSuccess(false);
          }, 1500);
        },
        function (_err) {},
      );
    } else if (window.clipboardData) {
      // Internet Explorer
      window.clipboardData.setData("Text", template);
      setSuccess(true);
      setTimeout(function () {
        setSuccess(false);
      }, 1500);
    }
  };

  return (
    <>
      {groups && groups.length > 0 && (
        <StyleMenu
          keepMounted
          anchorEl={anchorEl}
          id="long-menu"
          open={open}
          variant="menu"
          onClose={handleClose}
        >
          <StyledListSubheader>
            <Grid container>
              <Grid item xs={11}>
                Grupos
              </Grid>
              <Grid item xs={1}>
                <Tooltip open={success} title={"Copied Succesfully"}>
                  <IconButton size="small" onClick={handleCopy}>
                    <FileCopyIcon fontSize="inherit" />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </StyledListSubheader>

          {groups.map((groupName, i) => (
            <MenuItem key={`menu-item-${i}`} dense button={false} divider={i !== groups.length - 1}>
              {groupName}
            </MenuItem>
          ))}
        </StyleMenu>
      )}
    </>
  );
};

GroupList.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any,
  handleClose: PropTypes.func.isRequired,
};

export default GroupList;
